import type {ManifestationV4} from 'services/metadata/types';

export const getManifestationTitle = (
  manifestation: ManifestationV4 | undefined,
): string | undefined => {
  return manifestation
    ? manifestation.mainTitles?.map(mt => mt.value).join(', ')
    : undefined;
};
